import { useKeycloakAuth } from '@/contexts/keycloak-auth-context';

/**
 * Custom hook to get the current authenticated user
 * This is a convenience hook that wraps the useAuth hook
 */
export const useCurrentUser = () => {
  const { user } = useKeycloakAuth();
  return user;
};
